import type { AxiosResponse } from "axios";
import { get } from "../../../hook/request";
import type { RapportinoApiItem, RapportinoListItem } from "./type";

function toNumber(value?: number | string | null): number | undefined {
  if (value === null || value === undefined || value === "") return undefined;
  const n = Number(value);
  return Number.isFinite(n) ? n : undefined;
}

function mapRapportino(item: RapportinoApiItem): RapportinoListItem {
  return {
    id: Number(item.ID),
    ragioneSociale: item.ragionesociale ?? "",
    dataIns: item.data_ins ?? null,
    path: item.path ?? null,
    oreFactory: toNumber(item.ore_factory),
    oreCliente: toNumber(item.ore_cliente),
    dataInizio: item.data_inizio ?? null,
    dataFine: item.data_fine ?? null,
  };
}

export async function getRapportini(): Promise<RapportinoListItem[]> {
  const res: AxiosResponse<RapportinoApiItem[] | { data?: RapportinoApiItem[] }> = await get(
    "/report/rapportini"
  );
  const payload = (res as any)?.data ?? res;
  const list: RapportinoApiItem[] = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
      ? payload.data
      : [];

  return list.map(mapRapportino);
}
